import { useContext } from 'react';
import Contact from './components/contacts/Contact';
import Hero from './components/hero/Hero';
import ProjectList from './components/projectList/ProjectList';
import Toggle from './components/toggle/Toggle';
import { ThemeContext } from './context';

const App = () => {
	const theme = useContext(ThemeContext);
	const darkMode = theme.state.darkMode;
	return (
		<div
			style={{
				backgroundColor: darkMode ? '#222' : '#fff',
				color: darkMode && '#fff',
			}}
		>
			<Toggle />
			<Hero />
			<ProjectList />
			<Contact />
		</div>
	);
};

export default App;
